module.exports = __webpack_public_path__ + "static/media/27.59694e12.png";